import { Dialog, DialogContent, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";
import LoadingOverlay from "src/containers/LoadingOverlay/LoadingOverlay";
import AddEditButton from "src/reusable-components/AddEditButton/AddEditButton";
import DialogTitle from "../../DialogTitle/DialogTitle";
import SendMassAnomaliesNotificationsWrapper from "../SendMassAnomaliesNotificationsWrapper/SendMassAnomaliesNotificationsWrapper";
import NewSendMassSignoffRequestsWrapper from "../TnATimeSheetConfirmation/SendMassSignoffRequests/NewSendMassSignoffRequestsWrapper";

interface Props {
  // item?: TnADayDataWithBreaksRef | TnADayDataDTO;
  handleNotifyParent: () => void;
  children?: React.ReactNode;
  buttonText?: string;
  buttonVariant?: "text" | "outlined" | "contained";
  customButtonStyle?: React.CSSProperties;
  buttonTitle?: string;
  disabled?: boolean;
}

export interface State {
  lastNotifiedOn: string;
  lastSignOffOn: string;
  loading: boolean;
  error: string;
  isOpen: boolean;
  isAnomaliesView: boolean;
}

const SendMassNotificationsWrapper = ({
  // item,
  handleNotifyParent,
  children,
  buttonText,
  buttonVariant,
  customButtonStyle,
  buttonTitle,
  disabled = false,
}: Props) => {
  const tRP = "components.team_presence_and_leaves_mass_notifications";
  const { t } = useTranslation();

  const [state, setState] = useState<State>({
    lastNotifiedOn: "",
    lastSignOffOn: "",
    loading: false,
    error: "",
    isOpen: false,
    isAnomaliesView: false,
  });

  const changeView = useCallback((isAnomaliesView: boolean) => {
    setState((state) => ({
      ...state,
      isAnomaliesView,
    }));
  }, []);

  const handleNotify = useCallback(() => {
    setState((state) => ({ ...state, isOpen: false, isAnomaliesView: false }));
    handleNotifyParent();
    // if (isMutated.current) {
    //   handleNotifyParent();
    // }
  }, [handleNotifyParent]);

  const handleClose = useCallback(() => {
    setState((state) => ({ ...state, isAnomaliesView: false, isOpen: false }));
  }, []);

  // add unauthorized view
  // const hasAccess = useAuthorization([AUTHORIZATIONS.EmployeesAccess.ApproveTimeAndLeaves]);

  return (
    <>
      <AddEditButton
        title={buttonTitle ?? buttonText ?? t(`${tRP}.send_mass_notifications`)}
        effect={"edit"}
        onClick={() => {
          setState((state) => ({ ...state, isOpen: true }));
          // item?.employee?.id && loadItems();
        }}
        {...(!children && buttonText && { buttonText })}
        {...(buttonVariant && { buttonVariant })}
        {...(customButtonStyle && { customStyle: customButtonStyle })}
        {...(disabled && { disabled })}
      >
        {children}
      </AddEditButton>

      <Dialog
        open={state.isOpen}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              maxWidth: "90% !important",
              // maxHeight: "90% !important",
            },
          },
          "& .MuiDialogActions-root": {
            padding: "0 !important",
          },
          // "& .MuiGrid-root:first-of-type": {
          //   width: "100% !important",
          // },
        }}
      >
        {state.isOpen && (
          <>
            <DialogTitle
              title={t(`${tRP}.table_title`)}
              handleClose={handleClose}
              additionalSection={
                <>
                  <RadioGroup
                    row
                    value={state.isAnomaliesView ? "anomalies" : "signoff"}
                    onChange={(e) => changeView(e.target.value === "anomalies")}
                    sx={{ gap: 2 }}
                  >
                    <FormControlLabel
                      value="signoff"
                      control={<Radio />}
                      label={t(`${tRP}.send_signoff_requests`)}
                    />
                    <FormControlLabel
                      value="anomalies"
                      control={<Radio />}
                      label={t(`${tRP}.send_anomalies_notifications`)}
                    />
                  </RadioGroup>

                  <Typography>
                    {state.isAnomaliesView
                      ? t(`${tRP}.list_of_employees_with_anomaly`)
                      : t(`${tRP}.list_of_employees_for_signoff_requests`)}
                  </Typography>
                </>
              }
            />
            <LoadingOverlay loading={state.loading}>
              <DialogContent sx={{ paddingTop: "0 !important" }}>
                {state.isAnomaliesView ? (
                  <SendMassAnomaliesNotificationsWrapper
                    handleNotifyParent={handleNotify}
                    handleParentClose={handleClose}
                  />
                ) : (
                  <NewSendMassSignoffRequestsWrapper
                    handleNotifyParent={handleNotify}
                    handleParentClose={handleClose}
                  />
                )}
              </DialogContent>
            </LoadingOverlay>
          </>
        )}
      </Dialog>
    </>
  );
};

export default React.memo(SendMassNotificationsWrapper);
